import { render, staticRenderFns } from "./SimpleTextComponent.vue?vue&type=template&id=d5f21344&scoped=true"
import script from "./SimpleTextComponent.vue?vue&type=script&lang=ts"
export * from "./SimpleTextComponent.vue?vue&type=script&lang=ts"
import style0 from "./SimpleTextComponent.vue?vue&type=style&index=0&id=d5f21344&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5f21344",
  null
  
)

export default component.exports